import { render } from "./ranking-charts.vue?vue&type=template&id=406f80da"
import script from "./ranking-charts.vue?vue&type=script&lang=ts"
export * from "./ranking-charts.vue?vue&type=script&lang=ts"
script.render = render

export default script